import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  variant = 'primary',
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-xl font-display font-extrabold uppercase tracking-wide text-center transition-colors duration-150 ease-soft';
  const variants: Record<string, string> = {
    primary: 'bg-accent text-canvas hover:bg-accent-strong',
    secondary: 'bg-surface-alt text-ink border border-lineStrong hover:bg-surface hover:border-accent'
  };
  const sizes: Record<string, string> = {
    md: 'px-5 py-3 text-sm md:text-base',
    lg: 'px-6 py-4 text-base md:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-180" data-mp="138we8l5fjegf">
      {children}
    </a>;
}